import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import styles from "styles/pages/Pages.module.scss"
import { RNCAResumenGet } from 'services/services-mia/RNCAResumenGet';
import XGrid from 'components/UI/Grid/XGrid';
import { useRecoilValue } from 'recoil';
import { userCredentials } from 'recoilState/GlobalState';
import { resumenDisponibles as titlesDisponibles, resumenTransferencias as titlesTransferencias, resumenRetiro as titlesRetiros, resumenAsignaciones as titlesAsignaciones } from 'consts/titulos-de-tablas';
import { v4 as uuidV4 } from "uuid";
import { Grid } from '@mui/material';
import { RNESMovimientoGet } from 'services/services-mia/RNESMovimientoGet';
export default function BasicTabs({ user }) {
    const [value, setValue] = useState(0);
    const credentials = useRecoilValue(userCredentials);
    const [disponibles, setDisponibles] = useState([]);
    const [transferencias, setTransferencias] = useState([]);
    const [retiros, setRetiros] = useState([]);
    const [asignaciones, setAsignaciones] = useState([]);
    useEffect(() => {
        getResumen();
    }, [])

    const getResumen = async () => {
        const response = await RNESMovimientoGet(credentials, { rnesAsignacionMSUId: user.id });
        const responseFilterDisponibles = response.filter((e) => e.rnesMovimientoTipo === "D")
        const responseFilterTransferencias = response.filter((e) => e.rnesMovimientoTipo === "T")
        const responseFilterRetiros = response.filter((e) => e.rnesMovimientoTipo === "R")
        const responseFilterAsignados = response.filter((e) => e.rnesMovimientoTipo === "A" || e.rnesMovimientoTipo === "D")
        const mapDisponibles = responseFilterDisponibles.map((e) => {
            return {
                id: uuidV4(),
                "Articulo": e.rnesArticuloNombre,
                "Cantidad": e.rnesMovimientoCantidad,
                // [titlesDisponibles[3]]: e.rnesAsignacionCantidadDisponible === 0 ? "No" : "Si",
                [titlesDisponibles[3]]: `${e.rnesMovimientoContraparteNombre} ${e.rnesMovimientoContraparteDNI ? "(" + e.rnesMovimientoContraparteDNI + ")" : ""}`,
                "Fecha disponible": e.rnesAsignacionFechaDisponible,
                "Fecha asignación": e.rnesAsignacionFHAlta
            }
        })
        const mapTransferencia = responseFilterTransferencias.map((e) => {
            return {
                id: uuidV4(),
                "Articulo": e.rnesArticuloNombre,
                "Cantidad": e.rnesMovimientoCantidad,
                // [titlesTransferencias[3]]: e.rnesAsignacionCantidadDisponible === 0 ? "No" : "Si",
                [titlesTransferencias[3]]: `${e.rnesMovimientoContraparteNombre} ${e.rnesMovimientoContraparteDNI ? "(" + e.rnesMovimientoContraparteDNI + ")" : ""}`,
                "Fecha disponible": e.rnesAsignacionFechaDisponible,
                "Fecha asignación": e.rnesAsignacionFHAlta
            }
        })
        const mapRetiros = responseFilterRetiros.map((e) => {
            return {
                id: uuidV4(),
                "Articulo": e.rnesArticuloNombre,
                "Cantidad": e.rnesMovimientoCantidad,
                // [titlesRetiros[3]]: e.rnesAsignacionCantidadDisponible === 0 ? "No" : "Si",
                [titlesRetiros[3]]: `${e.rnesMovimientoContraparteNombre} ${e.rnesMovimientoContraparteDNI ? "(" + e.rnesMovimientoContraparteDNI + ")" : ""}`,
                "Fecha disponible": e.rnesAsignacionFechaDisponible,
                "Fecha entrega": e.rnesMovimientoFH
            }
        });
        const mapAsignaciones = responseFilterAsignados.map((e) => {
            return {
                id: uuidV4(),
                "Articulo": e.rnesArticuloNombre,
                "Cantidad": e.rnesAsignacionCantidad,
                // [titlesAsignaciones[3]]: e.rnesAsignacionCantidadDisponible === 0 ? "No" : "Si",
                [titlesAsignaciones[3]]: `${e.rnesMovimientoContraparteNombre} ${e.rnesMovimientoContraparteDNI ? "(" + e.rnesMovimientoContraparteDNI + ")" : ""}`,
                "Fecha disponible": e.rnesAsignacionFechaDisponible,
                "Fecha asignación": e.rnesAsignacionFHAlta
            }
        });
        setDisponibles(mapDisponibles);
        setTransferencias(mapTransferencia);
        setRetiros(mapRetiros);
        setAsignaciones(mapAsignaciones);
    }


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <main className={styles.main}>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} width={"100%"}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered variant="fullWidth" >
                    <Tab label="Asignaciones" {...a11yProps(0)} />
                    <Tab label="Disponibles" {...a11yProps(1)} />
                    <Tab label="Transferencias" {...a11yProps(2)} />
                    <Tab label="Entregas" {...a11yProps(3)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0} >
                <XGrid rows={asignaciones} titles={titlesAsignaciones} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1} >
                <XGrid rows={disponibles} titles={titlesDisponibles} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2} >
                <XGrid rows={transferencias} titles={titlesTransferencias} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3} >
                <XGrid rows={retiros} titles={titlesRetiros} />
            </CustomTabPanel>


        </main>
    );
}


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            style={{ display: value !== index ? "none" : "flex" }}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}

            {...other}
        >
            <Grid container display={"flex"} justifyContent={"flex-start"}>
                <Grid item md="12" height={"60vh"} mt={4} >
                    {value === index && <>{children} </>}
                </Grid>

            </Grid>



        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}